import { render, staticRenderFns } from "./add-patient-dialog.vue?vue&type=template&id=e1fc55c6&"
import script from "./add-patient-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-patient-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-patient-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports